<template>
  <nav
    ref="navRef"
    class="flex items-center relative transition-all duration-500 ease-out"
    :style="{ gap: `${menuGap}px` }"
  >
    <div class="flex flex-row items-center justify-between container mx-auto gap-2 sm:gap-4 px-4 sm:px-30">
      <img
        :src="logoUrl"
        alt="Logo"
        class="object-contain transition-all duration-500 ease-out w-20 sm:w-24 md:w-32 lg:w-auto md:mt-[14px] cursor-pointer"
        :style="logoStyle"
        @click="router.push('/home.html')"
      >

      <!-- 移动端汉堡菜单按钮 -->
      <div class="lg:hidden flex flex-col items-end justify-center gap-2">
        <div class="text-[#07409d] text-[12px] font-bold">
          联系电话(同微信):13052585965
        </div>
        <button
          @click="toggleMobileMenu"
          class="flex flex-col items-center justify-center w-8 h-8 gap-1.5 z-50"
          aria-label="Toggle menu"
        >
          <span
            class="block w-6 h-0.5 transition-all duration-300"
            :class="{ 
              'rotate-45 translate-y-2': isMobileMenuOpen,
              'bg-black': isScrollingUp && scrollY > 50,
              'bg-white': !(isScrollingUp && scrollY > 50)
            }"
          ></span>
          <span
            class="block w-6 h-0.5 transition-all duration-300"
            :class="{ 
              'opacity-0': isMobileMenuOpen,
              'bg-black': isScrollingUp && scrollY > 50,
              'bg-white': !(isScrollingUp && scrollY > 50)
            }"
          ></span>
          <span
            class="block w-6 h-0.5 transition-all duration-300"
            :class="{ 
              '-rotate-45 -translate-y-2': isMobileMenuOpen,
              'bg-black': isScrollingUp && scrollY > 50,
              'bg-white': !(isScrollingUp && scrollY > 50)
            }"
          ></span>
        </button>
      </div>

      <!-- 桌面端菜单 -->
      <div class="hidden lg:flex flex-col items-center justify-between">
        <div class="text-right text-[#07409d] font-bold transition-all duration-300 w-full text-sm mb-[14px]">
          联系电话(同微信):13052585965
        </div>
        <div class="flex flex-row items-center justify-center gap-12 xl:gap-20 w-full">
          <div
            v-for="item in menuArray"
            :key="item.path"
            class="flex flex-col items-center justify-center cursor-pointer relative"
            @mouseenter="handleMouseEnter(item.path)"
            @mouseleave="handleMouseLeave()"
          >
            <!-- 菜单项容器 -->
            <div
              class="flex flex-col items-center justify-center"
              @click="handleMenuClick(item.path)"
            >
              <!-- 菜单项文字 -->
              <div
                class="text-white py-0 px-0 transition-all duration-500 ease-out whitespace-nowrap text-base xl:text-xl 2xl:text-2xl"
                :style="{ fontSize: isLargeScreen ? `${textSize}px` : undefined }"
                :class="{
                  'font-bold': isActive(item.path) || hoveredIndex === item.path
                }"
              >
                {{ item.name }}
              </div>

              <!-- 蓝色短横线 -->
              <div
                class="h-[10px] transition-all duration-300 
                 mt-1 rounded-full
                 text-center origin-center"
                :class="{
                  'w-full opacity-100': isActive(item.path) || hoveredIndex === item.path,
                  'w-0 opacity-0': !isActive(item.path) && hoveredIndex !== item.path,
                  'bg-[#1d4ed8]': isActive(item.path) && hoveredIndex === item.path,
                  'bg-[#07409d]': !(isActive(item.path) && hoveredIndex === item.path)
                }"
              ></div>
            </div>

            <!-- 子菜单 -->
            <div
              v-if="(item.path === '/product.html' ? productList.length > 0 : (item.children && item.children.length > 0)) && hoveredIndex === item.path"
              class="hidden lg:block fixed left-0 right-0 z-40"
              @mouseenter="handleMouseEnter(item.path)"
              @mouseleave="handleMouseLeave()"
              :style="{ top: submenuTop }"
            >
              <div class="w-full">
                <template v-if="item.path === '/product.html'">
                  <div class="flex flex-col lg:flex-row w-full bg-[#919DC2]/60">
                    <div class="flex-2 flex flex-row items-start justify-end">
                      <img
                        src="../../assets/img/vr_device.webp"
                        alt="vr_device"
                        class="w-full lg:w-[413px] h-auto lg:h-[228px] object-cover"
                      />
                    </div>
                    <div class="flex-3 bg-[#1D2D5E]/60 py-5 pl-4 lg:pl-[70px] flex flex-col lg:flex-row gap-4 lg:gap-8">
                      <!-- 左侧：XR大空间互动影片内容播控系统 -->
                      <div class="flex flex-col pr-4 lg:pr-12">
                        <div class="text-white text-lg lg:text-xl font-bold mb-4 lg:mb-3">
                          {{ xrProductType?.productTypeName || 'XR大空间互动影片内容播控系统' }}
                        </div>
                        <div v-if="xrProducts.length > 0">
                          <div
                            v-for="product in xrProducts"
                            :key="product.id"
                            class="flex mb-2 lg:mb-3 cursor-pointer transition-all duration-200"
                            @click="handleProductClick(product)"
                          >
                            <div class="text-white text-sm lg:text-base font-medium">{{ product.name }}</div>
                          </div>
                        </div>
                        <div
                          v-else
                          class="text-white/60 text-sm"
                        >
                          加载中...
                        </div>
                      </div>

                      <!-- 右侧：LBE VR大空间产品系列 -->
                      <div class="flex flex-col">
                        <div class="text-white text-lg lg:text-xl font-semibold mb-3">
                          {{ lbeProductType?.productTypeName || 'LBE VR大空间产品系列' }}
                        </div>
                        <div
                          v-if="lbeProducts.length > 0"
                          class="grid grid-cols-1 lg:grid-cols-2 gap-x-4 lg:gap-x-[52px] gap-y-[10px]"
                          :style="{ gridTemplateRows: `repeat(${Math.ceil(lbeProducts.length / 2)}, auto)` }"
                        >
                          <!-- 左列：前一半产品 -->
                          <template
                            v-for="(product, index) in leftColumnProducts"
                            :key="product.id"
                          >
                            <div
                              class="flex items-center justify-start gap-3 cursor-pointer transition-all duration-200"
                              :style="{ gridColumn: '1', gridRow: index + 1 }"
                              @click="handleProductClick(product)"
                            >
                              <div
                                v-if="product.icon"
                                class="w-6 h-6 shrink-0 rounded overflow-hidden"
                              >
                                <img
                                  :src="product.icon"
                                  :alt="product.name"
                                  class="w-full h-full object-cover"
                                  @error="handleImageError"
                                >
                              </div>
                              <div class="flex items-center gap-2">
                                <span class="text-white text-sm font-[w400] leading-tight">{{ formatProductName(product.name) }}</span>
                              </div>
                            </div>
                          </template>
                          <!-- 右列：后一半产品 -->
                          <template
                            v-for="(product, index) in rightColumnProducts"
                            :key="product.id"
                          >
                            <div
                              class="flex items-center justify-start gap-3 cursor-pointer transition-all duration-200"
                              :style="{ gridColumn: '2', gridRow: index + 1 }"
                              @click="handleProductClick(product)"
                            >
                              <div
                                v-if="product.icon"
                                class="w-6 h-6 shrink-0 rounded overflow-hidden"
                              >
                                <img
                                  :src="product.icon"
                                  :alt="product.name"
                                  class="w-full h-full object-cover"
                                  @error="handleImageError"
                                >
                              </div>
                              <div class="flex items-center gap-2">
                                <span class="text-white text-sm font-medium leading-tight">{{ formatProductName(product.name) }}</span>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div
                          v-else
                          class="text-white/60 text-sm"
                        >
                          加载中...
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="item.path === '/solution.html'">
                  <div class="flex flex-col lg:flex-row w-full bg-[#919DC2]/60">
                    <div class="flex-1 flex flex-row items-start justify-end">
                      <img
                        src="../../assets/img/jjfa_icon.webp"
                        alt="vr_device"
                        class="w-full lg:w-[249px] h-auto lg:h-[137px] object-cover"
                      />
                    </div>
                    <!-- 解决方案子菜单 - 两列布局 -->
                    <div class="flex flex-row flex-1 bg-[#1D2D5E]/60 justify-start pl-4 lg:pl-10 py-4 lg:py-0 gap-8 lg:gap-12">
                      <!-- 第一列：前3个菜单项 -->
                      <div class="flex flex-col">
                        <div
                          v-for="child in (item.children ?? []).slice(0, 3)"
                          :key="child.path"
                          class="px-4 py-2 text-white text-sm lg:text-base cursor-pointer transition-colors rounded hover:bg-white/10"
                          @click="handleMenuClick(child.path)"
                        >
                          {{ child.name }}
                        </div>
                      </div>
                      <!-- 第二列：剩余的菜单项 -->
                      <div class="flex flex-col">
                        <div
                          v-for="child in (item.children ?? []).slice(3)"
                          :key="child.path"
                          class="px-4 py-2 text-white text-sm lg:text-base cursor-pointer transition-colors rounded hover:bg-white/10"
                          @click="handleMenuClick(child.path)"
                        >
                          {{ child.name }}
                        </div>
                      </div>
                    </div>

                  </div>

                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 移动端菜单遮罩层 -->
      <transition
        enter-active-class="transition-opacity duration-300 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-300 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="isMobileMenuOpen"
          class="lg:hidden fixed inset-0 z-40"
          @click="closeMobileMenu"
        ></div>
      </transition>

      <!-- 移动端菜单抽屉 -->
      <transition
        enter-active-class="transition-transform duration-300 ease-out"
        enter-from-class="translate-x-full"
        enter-to-class="translate-x-0"
        leave-active-class="transition-transform duration-300 ease-in"
        leave-from-class="translate-x-0"
        leave-to-class="translate-x-full"
      >
        <div
          v-if="isMobileMenuOpen"
          class="lg:hidden fixed left-0 right-0 w-full bg-[#1D2D5E]/80 z-50 overflow-y-auto shadow-2xl flex flex-col"
          :style="{ top: mobileMenuTop }"
        >
          <!-- 菜单项区域 -->
          <div class="flex-1 px-4 py-6 w-full">
            <div class="flex flex-col gap-0">
              <div
                v-for="item in menuArray"
                :key="item.path"
                class="relative"
              >
                <div
                  class="text-white text-lg font-semibold py-2 px-4 cursor-pointer transition-all duration-200 flex items-center justify-between"
                  @click="toggleSubmenu(item.path)"
                >
                  <div class="flex items-center gap-3 flex-1">
                    <!-- 左侧竖条（仅激活项显示） -->
                    <div
                      v-if="isActive(item.path)"
                      class="w-1 h-6 bg-[#1d4ed8] rounded-full shrink-0"
                    ></div>
                    <div
                      v-else
                      class="w-1 h-6 bg-transparent rounded-full shrink-0"
                    ></div>
                    <div
                      @click.stop="handleMenuClick(item.path)"
                      class="w-full"
                    >{{ item.name }}</div>
                  </div>
                  <span
                    v-if="(item.path === '/product.html' ? productList.length > 0 : (item.children && item.children.length > 0))"
                    class="text-white text-xl shrink-0 px-4 py-2 -mr-2 -my-2 min-w-[44px] min-h-[44px] flex items-center justify-center cursor-pointer"
                    @click.stop="toggleSubmenu(item.path)"
                  >
                    {{ openSubmenu === item.path ? '−' : '+' }}
                  </span>
                </div>

                <!-- 移动端子菜单 -->
                <div
                  v-if="(item.path === '/product.html' ? productList.length > 0 : (item.children && item.children.length > 0)) && openSubmenu === item.path"
                  class="mt-2 pl-8 pr-4 space-y-1 pb-4"
                >
                  <!-- 产品菜单：显示产品列表 -->
                  <template v-if="item.path === '/product.html'">
                    <!-- XR产品 -->
                    <div
                      v-if="xrProducts.length > 0"
                      class="mb-4"
                    >
                      <div class="text-white/70 text-sm font-semibold mb-2">XR产品</div>
                      <div
                        v-for="product in xrProducts"
                        :key="product.id"
                        class="text-white/90 text-base py-2 cursor-pointer hover:text-white transition-colors pl-4"
                        :class="{ 'text-white font-semibold': isActive(`/product/${product.id}.html`) }"
                        @click="handleProductClick(product)"
                      >
                        {{ formatProductName(product.name) }}
                      </div>
                    </div>
                    <!-- LBE产品 -->
                    <div v-if="lbeProducts.length > 0">
                      <div class="text-white/70 text-sm font-semibold mb-2">LBE产品</div>
                      <div
                        v-for="product in lbeProducts"
                        :key="product.id"
                        class="text-white/90 text-base py-2 cursor-pointer hover:text-white transition-colors pl-4"
                        :class="{ 'text-white font-semibold': isActive(`/product/${product.id}.html`) }"
                        @click="handleProductClick(product)"
                      >
                        {{ formatProductName(product.name) }}
                      </div>
                    </div>
                  </template>
                  <!-- 其他菜单：显示子菜单 -->
                  <template v-else>
                    <div
                      v-for="child in item.children"
                      :key="child.path"
                      class="text-white/90 text-base py-2 cursor-pointer hover:text-white transition-colors"
                      :class="{ 'text-white font-semibold': isActive(child.path) }"
                      @click="handleMenuClick(child.path)"
                    >
                      {{ child.name }}
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import logo from "@/assets/img/logo.webp";
import { productApi, type ProductType } from "@/api";
import { RequestError } from "@/utils/request";

const logoUrl = logo;

interface Props {
  textScale?: number;
  logoStyle?: { width?: string; height?: string };
}

const props = withDefaults(defineProps<Props>(), {
  textScale: 1.0,
  logoStyle: () => ({}),
});

const route = useRoute();
const router = useRouter();

// 计算文字大小
const textSize = computed(() => {
  const baseSize = 24;
  return baseSize * props.textScale;
});

// 计算间距
const menuGap = computed(() => {
  const baseGap = 75;
  return baseGap * props.textScale;
});

// 检测大屏幕
const windowWidth = ref(
  typeof window !== "undefined" ? window.innerWidth : 1920
);
const isLargeScreen = computed(() => {
  return windowWidth.value >= 1536;
});

// 监听窗口大小变化
const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

// 滚动相关状态（用于移动端菜单按钮颜色）
const scrollY = ref(0);
const lastScrollY = ref(0);
const isScrollingUp = ref(false);

// 滚动处理函数（使用节流优化性能）
let scrollTimer: ReturnType<typeof setTimeout> | null = null;

const handleScroll = () => {
  // 清除之前的定时器
  if (scrollTimer) {
    clearTimeout(scrollTimer);
  }

  // 节流处理，每16ms执行一次（约60fps）
  scrollTimer = setTimeout(() => {
    const currentScrollY = window.scrollY || window.pageYOffset;

    // 判断滚动方向（使用阈值避免微小滚动触发）
    const scrollThreshold = 5;
    if (
      currentScrollY > lastScrollY.value + scrollThreshold &&
      currentScrollY > 50
    ) {
      // 向下滚动（上滑）
      isScrollingUp.value = true;
    } else if (currentScrollY < lastScrollY.value - scrollThreshold) {
      // 向上滚动（下滑）
      isScrollingUp.value = false;
    }

    scrollY.value = currentScrollY;
    lastScrollY.value = currentScrollY;
  }, 16);
};

interface MenuItem {
  name: string;
  path: string;
  children?: MenuItem[];
  category?: "xr" | "lbe";
  icon?: string;
}

// 产品列表数据
const productList = ref<ProductType[]>([]);

// 计算属性：XR产品类型（第一个类型）
const xrProductType = computed(() => {
  return productList.value[0] || null;
});

// 计算属性：LBE产品类型（第二个类型）
const lbeProductType = computed(() => {
  return productList.value[1] || null;
});

// 计算属性：XR产品列表
const xrProducts = computed(() => {
  return xrProductType.value?.products || [];
});

// 计算属性：LBE产品列表
const lbeProducts = computed(() => {
  return lbeProductType.value?.products || [];
});

// 计算属性：左列产品（前一半）
const leftColumnProducts = computed(() => {
  return lbeProducts.value.slice(0, 5);
});

// 计算属性：右列产品（后一半）
const rightColumnProducts = computed(() => {
  return lbeProducts.value.slice(5);
});

const menuArray: MenuItem[] = [
  {
    name: "首页",
    path: "/home.html",
  },
  {
    name: "产品",
    path: "/product.html",
    children: [], // 子菜单现在由动态数据生成
  },
  {
    name: "解决方案",
    path: "/solution.html",
    children: [
      {
        name: "XR剧院内容及管理方案",
        path: "/xr-theater.html",
      },
      // {
      //   name: "XR大空间地产家装方案",
      //   path: "/xr-home.html",
      // },
      {
        name: "LBE大空间定制开发方案",
        path: "/lbe-custom.html",
      },
      {
        name: "VR 大空间方案",
        path: "/vrSpaceSolutions.html",
      },
      {
        name: "XR沉浸式研学方案",
        path: "/xr-immersiveLearning.html",
      },
    ],
  },
  {
    name: "服务案例",
    path: "/service.html",
  },
  {
    name: "资讯中心",
    path: "/news.html",
  },
  {
    name: "联系我们",
    path: "/contact.html",
  },
];

// 当前悬停的菜单项
const hoveredIndex = ref<string | null>(null);

// 移动端菜单状态
const isMobileMenuOpen = ref(false);
const openSubmenu = ref<string | null>(null);

// 切换移动端菜单
const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
  if (!isMobileMenuOpen.value) {
    openSubmenu.value = null;
  }
};

// 关闭移动端菜单
const closeMobileMenu = () => {
  isMobileMenuOpen.value = false;
  openSubmenu.value = null;
};

// 切换子菜单
const toggleSubmenu = (path: string) => {
  if (openSubmenu.value === path) {
    openSubmenu.value = null;
  } else {
    openSubmenu.value = path;
  }
};

// 导航栏高度
const navbarHeight = ref(0);
const navRef = ref<HTMLElement | null>(null);

// 计算子菜单的 top 位置（桌面端）
const submenuTop = computed(() => {
  return `${navbarHeight.value}px`;
});

// 计算移动端菜单的 top 位置
const mobileMenuTop = computed(() => {
  // 移动端菜单紧贴导航栏底部
  // 由于导航栏高度已经包含了所有 padding，所以直接使用即可
  return `${navbarHeight.value}px`;
});

// 更新导航栏高度
const updateNavbarHeight = () => {
  // 直接通过 DOM 查询找到导航栏容器
  const navbarContainer = document.querySelector(
    ".not-scrolled_header"
  ) as HTMLElement;
  if (navbarContainer) {
    // 获取整个导航栏容器的实际高度（包括 padding）
    navbarHeight.value = navbarContainer.offsetHeight;
  } else if (navRef.value) {
    // 如果找不到，使用 navRef 的高度作为后备
    navbarHeight.value = navRef.value.offsetHeight;
  }
};

onMounted(async () => {
  // 等待 DOM 完全渲染后再更新
  await nextTick();
  updateNavbarHeight();
  // 加载产品列表
  loadProductList();
  // 监听窗口大小变化
  window.addEventListener("resize", updateNavbarHeight);
  window.addEventListener("resize", handleResize);
  // 监听滚动事件（用于移动端菜单按钮颜色和更新导航栏高度）
  window.addEventListener(
    "scroll",
    () => {
      handleScroll();
      updateNavbarHeight(); // 滚动时也更新高度（因为导航栏可能缩放）
    },
    { passive: true }
  );
  scrollY.value = window.scrollY || window.pageYOffset;
  lastScrollY.value = scrollY.value;
  // 使用 MutationObserver 监听导航栏高度变化（因为缩放可能导致高度变化）
  if (navRef.value) {
    const observer = new MutationObserver(() => {
      updateNavbarHeight();
    });
    observer.observe(navRef.value, {
      attributes: true,
      attributeFilter: ["style", "class"],
      childList: true,
      subtree: true,
    });
    // 也监听父元素的变化
    let parent = navRef.value.parentElement;
    while (parent) {
      if (parent.classList.contains("not-scrolled_header")) {
        observer.observe(parent, {
          attributes: true,
          attributeFilter: ["style", "class"],
          childList: true,
          subtree: true,
        });
        break;
      }
      parent = parent.parentElement;
    }
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateNavbarHeight);
  window.removeEventListener("resize", handleResize);
  window.removeEventListener("scroll", handleScroll);
  if (scrollTimer) {
    clearTimeout(scrollTimer);
  }
});

// 判断菜单项是否激活（包括子菜单）
const isActive = (path: string) => {
  return route.path === path || route.path.startsWith(path + "/");
};

// 处理菜单点击
const handleMenuClick = (path: string) => {
  router.push(path);
  hoveredIndex.value = null; // 点击后关闭子菜单
  closeMobileMenu(); // 移动端点击后关闭菜单
};

// 延迟关闭定时器
let leaveTimer: ReturnType<typeof setTimeout> | null = null;

// 处理鼠标进入
const handleMouseEnter = (path: string) => {
  // 清除关闭定时器
  if (leaveTimer) {
    clearTimeout(leaveTimer);
    leaveTimer = null;
  }
  hoveredIndex.value = path;
};

// 处理鼠标离开（延迟关闭，以便移动到子菜单）
const handleMouseLeave = () => {
  // 清除之前的定时器
  if (leaveTimer) {
    clearTimeout(leaveTimer);
  }

  // 延迟关闭，允许鼠标移动到子菜单
  leaveTimer = setTimeout(() => {
    hoveredIndex.value = null;
    leaveTimer = null;
  }, 150);
};

/**
 * 根据产品生成路由路径
 * 跳转到 /product/:id.html
 */
const getProductRoute = (product: { name: string; id: string }): string => {
  return `/product/${product.id}.html`;
};

/**
 * 格式化产品名称（去掉 "LBE产品" 后缀）
 */
const formatProductName = (name: string): string => {
  return name.replace(/LBE产品$/, "");
};

/**
 * 处理产品点击
 */
const handleProductClick = (product: { name: string; id: string }) => {
  if (product.name === "ENUMSHOW播控系统") {
    handleMenuClick("/product.html");
  } else {
    const route = getProductRoute(product);
    handleMenuClick(route);
  }
};

/**
 * 图片加载错误处理
 */
const handleImageError = (event: Event) => {
  const img = event.target as HTMLImageElement;
  img.style.display = "none";
};

/**
 * 加载产品列表
 */
const loadProductList = async () => {
  try {
    const response = await productApi.getProductList();
    if (response.code === 200 && response.data) {
      productList.value = response.data;
    } else {
      console.warn("Navbar 产品列表响应格式异常:", response);
    }
  } catch (error) {
    console.error("加载产品列表失败:", error);
    if (error instanceof RequestError) {
      console.error("错误信息:", error.message);
    }
  }
};
</script>
